const DEFAULT_DATA_SOURCE_ID = 'default';

export interface StorageScope {
  userId?: string | number | null;
  appDataSourceId?: string | number | null;
  instanceHost?: string | null;
}

/**
 * Builds a localStorage key scoped to a user, data source, and (on native) instance.
 */
const scopedStorageKey = (prefix: string, { userId, appDataSourceId, instanceHost }: StorageScope) => {
  const base = `${prefix}:${String(userId ?? 'anonymous')}:${appDataSourceId || DEFAULT_DATA_SOURCE_ID}`;
  return instanceHost ? `${base}:${instanceHost}` : base;
};

export default scopedStorageKey;
